import React, { useContext } from 'react';
import styled from 'styled-components';
import AdditionalFields from 'integrations/aws/common/AdditionalFields';
import FormDataContext from 'integrations/contexts/FormDataContext';

import { Input } from 'components/bootstrap';

import { AdvancedOptionsContext } from '../common/context/AdvancedOptions';
import type { HandleFieldUpdateType } from '../common/utils/types';

const StyledAdditionalFields = styled(AdditionalFields)`
  margin: 0 0 35px;
`;

interface Props {
  onChange: HandleFieldUpdateType;
}

const FormAdvancedOptions: React.FC<Props> = ({ onChange }) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);

  const { overrideSource, onePasswordThrottleEnabled, onePasswordStoreFullMessage } = formData;

  const handleToggle: (visible: boolean) => void = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };

  return (
    <StyledAdditionalFields title="Advanced Options" visible={isAdvancedOptionsVisible} onToggle={handleToggle}>
      <Input
        id="onePasswordThrottleEnabled"
        type="checkbox"
        value="enable-throttling"
        defaultChecked={onePasswordThrottleEnabled?.value}
        onChange={onChange}
        label="Enable Throttling"
        help="If enabled, no new messages will be read from this input until the server catches up with its message load. This is typically useful for inputs reading from files or message queue systems like AMQP or Kafka. If you regularly poll an external system, e.g. via HTTP, you normally want to leave this disabled."
      />
      <Input
        id="onePasswordStoreFullMessage"
        type="checkbox"
        value="enable-storeFullMessage"
        defaultChecked={onePasswordStoreFullMessage?.value}
        onChange={onChange}
        label="Store Full Message"
        help="Store the full original 1Password event record message as full_message?"
      />
      <Input
        id="overrideSource"
        type="text"
        value={overrideSource?.value}
        onChange={onChange}
        label="Override Source (optional)"
        help="The source is set to 1password by default. Set this if you want to override it with a custom value."
      />
    </StyledAdditionalFields>
  );
};

export default FormAdvancedOptions;
